/**
 * Mitteilung Model
 *
 * This file is part of Zeus Apollon
 *
 * (c) Kaden und Partner AG
 */
import { BaseModel } from '@/models/BaseModel'
import { BaseCollection } from './BaseCollection'
import dayjs, { Dayjs } from 'dayjs'
import type { MutationsObject } from '@kp/js-model'

export type Attachment = {
    id: number
    mitteilung_id: number
    filename: string
    orig_filename: string
    mime: string
    ersteller_id: number
    created: string
}
export const MODE = {
    STANDARD: 'standard',
    BROADCAST: 'broadcast',
    ENERGIEFACHSTELLE: 'energiefachstelle',
}
export class Mitteilung extends BaseModel {
    id: number | null = null
    gesuch_id: number | null = null
    zeus_ersteller_id: number | null = null
    apollon_ersteller_id: number | null = null
    created: Dayjs | null = null
    modified: Dayjs | null = null
    deleted_at: Dayjs | null = null
    subject: string | null = null
    mitteilung: string | null = null
    ersteller_rolle: string | null = null
    empfaenger_email: string[] | null = []
    mode: string | null = null

    //  number | null =View fields;
    gesuch_nummer: string | null = null
    ersteller: string | null = null
    ersteller_telefon: string | null = null
    empfaenger_rollen: string[] | null = []
    empfaenger_apollon_ids: number[] | null = []
    gelesen_zeus_ids: number[] | null = []
    gelesen_apollon_ids: number[] | null = []
    gelesen_rollen: string[] | null = []
    attachments: Attachment[] | null = []
    is_deleted: boolean | null = false

    static get ROLLE_GESUCHSPRUEFER() {
        return 'gesuchspruefer'
    }

    public mutations(): MutationsObject {
        return {
            id: (id) => (Number(id) > 0 ? Number(id) : null),
            gesuch_id: (id) => (Number(id) > 0 ? Number(id) : null),
            zeus_ersteller_id: (id) => (Number(id) > 0 ? Number(id) : null),
            apollon_ersteller_id: (id) => (Number(id) > 0 ? Number(id) : null),
            created: dayjs,
            modified: dayjs,
            deleted_at: dayjs,
            is_deleted: Boolean,
        }
    }

    getClassName(): string {
        return 'mitteilung'
    }

    /** custom request to request deletion (but not remove from collection) */
    markDeleted() {
        throw new Error('Not implemented')
        // let method = this.getOption('methods.delete');
        // let route = this.getRoute('delete');
        // let params = this.getRouteParameters();
        // let url = this.getURL(route, params);

        // return this.createRequest({ method, url }).send();
    }
}

export class MitteilungCollection extends BaseCollection<Mitteilung> {
    protected modelCls = Mitteilung

    public getModelClassName(): string {
        return 'mitteilung'
    }
}
